import type { SelectOption } from '@c/forms/controls/FormSelect';
import SafeImage from '@ui/SafeImage';
import { capitalize } from 'lodash';
import { CreditCardIcon } from 'lucide-react';
import type { PaymentDocument } from 'models/payment';

export function buildPaymentOptions(
  paymentMethodData?: PaymentDocument[]
): SelectOption[] {
  return (
    paymentMethodData?.map((paymentMethod) => ({
      id: paymentMethod.id ?? '',
      label: `${capitalize(paymentMethod.brand)} - ${paymentMethod.last4}`,
      value: paymentMethod.id ?? '',
      selectedDisplay: (
        <div className="flex items-center gap-2">
          {['visa', 'mastercard', 'amex'].includes(paymentMethod.brand ?? '') ? (
            <SafeImage
              src={`/cc_brands/${paymentMethod.brand?.toLowerCase()}.png`}
              alt={paymentMethod.brand ?? ''}
              width={32}
              height={20}
              className="mr-2 h-12 w-16 object-contain"
            />
          ) : (
            <CreditCardIcon className="h-12 w-12" />
          )}
          <span>{`Card ending in ${paymentMethod.last4}`}</span>
        </div>
      ),
    })) ?? []
  );
}
